import i18n from 'i18next';

export const MAX_LETTER_COUNT = 300;

export const FeedbackTextValues = {
  unclearAnswer: i18n.t(
    'pages.parentHelper.chat.body.feedbackDislikeDialog.unclearAnswer',
  ),
  incorrectInformation: i18n.t(
    'pages.parentHelper.chat.body.feedbackDislikeDialog.incorrectInformation',
  ),
  notHelpful: i18n.t(
    'pages.parentHelper.chat.body.feedbackDislikeDialog.notHelpful',
  ),
  other: i18n.t('pages.parentHelper.chat.body.feedbackDislikeDialog.other'),
};

export enum FieldsNames {
  FeedbackText = 'inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest.feedbackText',
  OtherFeedbackText = 'inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest.otherFeedbackText',
}
